import { render } from "./NewsPost.vue?vue&type=template&id=6e074df0&scoped=true"
import script from "./NewsPost.vue?vue&type=script&lang=js"
export * from "./NewsPost.vue?vue&type=script&lang=js"

import "./NewsPost.vue?vue&type=style&index=0&id=6e074df0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e074df0"]])

export default __exports__